export const PM_PORTALS_GET = 'PM_PORTALS_GET'
export const PM_PORTALS_SET = 'PM_PORTALS_SET'
export const PM_PORTALS_SET_PROCESSING = 'PM_PORTALS_SET_PROCESSING'
export const PM_PORTALS_SET_ERROR = 'PM_PORTALS_SET_ERROR'

export function getPmPortals (payload) { // lists
  return {
    type: PM_PORTALS_GET,
    payload,
  }
}

export function setPmPortals (payload) {
  return {
    type: PM_PORTALS_SET,
    payload,
  }
}

export function setPmPortalsProcessing () {
  return {
    type: PM_PORTALS_SET_PROCESSING,
  }
}

export function setPmPortalsError (payload) {
  return {
    type: PM_PORTALS_SET_ERROR,
    payload,
  }
}
